import type { EgovApplicationPackageGroupByTagRow, EgovApplicationStepByTagRow } from '@/features/operation-packages/api';

/** Batch Job 実行中として一覧ポーリング対象となる統合ステータス */
const EGOV_APPLICATION_BATCH_PROCESSING_STATUSES = ['submitting', 'amending', 'withdrawInProgress', 'syncing'] as const satisfies readonly EgovApplicationStepByTagRow['status'][];
export type EgovApplicationBatchProcessingStatus = (typeof EGOV_APPLICATION_BATCH_PROCESSING_STATUSES)[number];
export function isEgovApplicationBatchProcessingStatus(status: EgovApplicationStepByTagRow['status']): status is EgovApplicationBatchProcessingStatus {
  return (EGOV_APPLICATION_BATCH_PROCESSING_STATUSES as readonly string[]).includes(status);
}
function hasBatchProcessingStep(step: Pick<EgovApplicationStepByTagRow, 'status'>): boolean {
  return isEgovApplicationBatchProcessingStatus(step.status);
}
export function hasEgovApplicationBatchProcessingRows(items: readonly (Pick<EgovApplicationStepByTagRow, 'status'> | Pick<EgovApplicationPackageGroupByTagRow, 'steps'>)[]): boolean {
  return items.some(item => {
    if ('steps' in item) {
      return item.steps.some(hasBatchProcessingStep);
    }
    return hasBatchProcessingStep(item);
  });
}